<template>
  <div class="faq">
    <div class="post-content">
      <div class="text-center title">{{ title }}</div>
      <div class="content" v-html="detail"></div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      detail: '',
      title: '',
    };
  },
  created() {
    this.queryDocumentDetail();
  },
  methods: {
    queryDocumentDetail() {
      this.$apis.documntServer.queryDocDetail({
        menuId: 113, // faq的菜单ID
      }).then(res => {
        if (res["code"] == 0) {
          this.detail = res.data.content;
          this.title = res.data.title;
        } else {
          this.errorMsg = res['msg'];
          this.$dialog.alert({
            message: res['msg'],
            confirmButtonColor: '#2537B5',
          });
        }
      })
    },
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/editor.css";
.faq {
  padding: 40px 20px;
}
.post-content .title {
  line-height: 60px;
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 30px !important;
}
</style>
